import React from 'react';
import { Box, Typography } from '@mui/material';

const DrawerUserInfo = ({ user }) => {
  // 오른쪽 위 헤더에 같은 이름·직급이 이미 있어서 PC 에서는 숨긴다(메뉴가 약 90px 위로 올라옴).
  // 모바일은 헤더가 좁아 잘 안 보이므로 얇은 한 줄로만 남긴다(2026-10-15).
  return (
    <Box
      sx={{
        display: { xs: 'block', md: 'none' },
        py: 0.75,
        px: 2,
        backgroundColor: '#37474f',
        color: '#fff',
      }}
    >
      <Typography variant="body2" component="div" noWrap>
        {user?.usrNm} {user?.gradeNm}
        {user?.dptNm && (
          <Box component="span" sx={{ color: '#cfd8dc' }}>
            {' · '}
            {user.dptNm}
          </Box>
        )}
      </Typography>
    </Box>
  );
};

export default DrawerUserInfo;
